// import { useState } from "react";
// import { FaRobot, FaTimes, FaPhoneAlt } from "react-icons/fa";

// const HelpCenter = () => {
//   const [open, setOpen] = useState(false);
//   const [messages, setMessages] = useState([
//     { type: "bot", text: "Hi 👋 How can I help you?" }
//   ]);

//   const options = [
//     "Order Status",
//     "Return Policy",
//     "Payment Issue",
//     "Talk to Support"
//   ];

//   const handleOptionClick = (option) => {
//     let reply = "";

//     switch (option) {
//       case "Order Status":
//         reply = "📦 You can track your order from 'My Orders' section.";
//         break;
//       case "Return Policy":
//         reply = "🔁 We offer 7 days return policy on all products.";
//         break;
//       case "Payment Issue":
//         reply = "💳 Please check your payment status or try again.";
//         break;
//       case "Talk to Support":
//         reply = "📞 Click below to call our support team.";
//         break;
//       default:
//         reply = "Sorry, I didn't understand.";
//     }

//     setMessages((prev) => [
//       ...prev,
//       { type: "user", text: option },
//       { type: "bot", text: reply }
//     ]);
//   };

//   return (
//     <div className="min-h-screen bg-gray-100 p-4">
      
//       {/* Page Content */}
//       <h1 className="text-2xl font-bold mb-4">Help Center</h1>
//       <p className="text-gray-600">
//         Need help? Chat with us or explore common queries.
//       </p>

//       {/* Chat Button */}
//       <button
//         onClick={() => setOpen(true)}
//         className="fixed bottom-5 right-5 bg-green-500 text-white p-4 rounded-full shadow-lg"
//       >
//         <FaRobot size={20} />
//       </button>

//       {/* Chatbot */}
//       {open && (
//         <div className="fixed bottom-20 right-5 w-[320px] bg-white rounded-xl shadow-lg flex flex-col">
          
//           {/* Header */}
//           <div className="bg-green-500 text-white p-3 flex justify-between items-center rounded-t-xl">
//             <span>Support Chat</span>
//             <FaTimes className="cursor-pointer" onClick={() => setOpen(false)} />
//           </div>

//           {/* Messages */}
//           <div className="p-3 h-[300px] overflow-y-auto space-y-2">
//             {messages.map((msg, i) => (
//               <div
//                 key={i}
//                 className={`p-2 rounded-lg text-sm max-w-[80%] ${
//                   msg.type === "bot"
//                     ? "bg-gray-200 self-start"
//                     : "bg-green-500 text-white self-end ml-auto"
//                 }`}
//               >
//                 {msg.text}
//               </div>
//             ))}
//           </div>

//           {/* Options */}
//           <div className="p-2 border-t space-y-2">
//             {options.map((opt, i) => (
//               <button
//                 key={i}
//                 onClick={() => handleOptionClick(opt)}
//                 className="w-full text-left px-3 py-2 bg-gray-100 rounded hover:bg-gray-200 text-sm"
//               >
//                 {opt}
//               </button>
//             ))}

//             {/* Call Now */}
//             <a
//               href="tel:9871238339"
//               className="flex items-center justify-center gap-2 bg-green-500 text-white py-2 rounded"
//             >
//               <FaPhoneAlt /> Call Now
//             </a>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default HelpCenter;
// import { useState } from "react";
// import { FaRobot, FaTimes, FaPhoneAlt } from "react-icons/fa";
// import { motion, AnimatePresence } from "framer-motion";

// const HelpCenter = () => {
//   const [open, setOpen] = useState(false);
//   const [messages, setMessages] = useState([
//     { type: "bot", text: "Hi 👋 How can I help you today?" }
//   ]);

//   const options = [
//     "Order Status",
//     "Return Policy",
//     "Payment Issue",
//     "Talk to Support"
//   ];

//   const handleOptionClick = (option) => {
//     let reply = "";

//     switch (option) {
//       case "Order Status":
//         reply = "📦 Track your order from 'My Orders' section.";
//         break;
//       case "Return Policy":
//         reply = "🔁 7 days easy return available.";
//         break;
//       case "Payment Issue":
//         reply = "💳 Try again or check payment status.";
//         break;
//       case "Talk to Support":
//         reply = "📞 You can call support below 👇";
//         break;
//       default:
//         reply = "Sorry, I didn't understand.";
//     }

//     setMessages((prev) => [
//       ...prev,
//       { type: "user", text: option },
//       { type: "bot", text: reply }
//     ]);
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-4">

//       {/* HEADER */}
//       <div className="mb-6">
//         <h1 className="text-3xl font-bold text-gray-800">Help Center</h1>
//         <p className="text-gray-500 text-sm">
//           Chat with us or find answers instantly 🚀
//         </p>
//       </div>

//       {/* FLOAT BUTTON */}
//       <motion.button
//         whileHover={{ scale: 1.1 }}
//         whileTap={{ scale: 0.9 }}
//         onClick={() => setOpen(true)}
//         className="fixed bottom-5 right-5 bg-gradient-to-r from-green-500 to-emerald-600 text-white p-4 rounded-full shadow-xl"
//       >
//         <FaRobot size={20} />
//       </motion.button>

//       {/* CHATBOT */}
//       <AnimatePresence>
//         {open && (
//           <motion.div
//             initial={{ opacity: 0, y: 50, scale: 0.9 }}
//             animate={{ opacity: 1, y: 0, scale: 1 }}
//             exit={{ opacity: 0, y: 50 }}
//             className="fixed bottom-20 right-5 w-[320px] bg-white/80 backdrop-blur-xl rounded-2xl shadow-2xl flex flex-col overflow-hidden border border-gray-200"
//           >

//             {/* HEADER */}
//             <div className="bg-gradient-to-r from-green-500 to-emerald-600 text-white p-3 flex justify-between items-center">
//               <div className="flex items-center gap-2">
//                 <FaRobot />
//                 <span className="font-semibold">Support Chat</span>
//               </div>
//               <FaTimes className="cursor-pointer" onClick={() => setOpen(false)} />
//             </div>

//             {/* MESSAGES */}
//             <div className="p-3 h-[300px] overflow-y-auto space-y-2 flex flex-col">

//               {messages.map((msg, i) => (
//                 <motion.div
//                   key={i}
//                   initial={{ opacity: 0, y: 10 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   className={`p-2 px-3 rounded-2xl text-sm max-w-[80%] ${
//                     msg.type === "bot"
//                       ? "bg-gray-200 self-start"
//                       : "bg-gradient-to-r from-green-500 to-emerald-600 text-white self-end ml-auto"
//                   }`}
//                 >
//                   {msg.text}
//                 </motion.div>
//               ))}

//             </div>

//             {/* OPTIONS */}
//             <div className="p-3 border-t space-y-2 bg-white">

//               {options.map((opt, i) => (
//                 <motion.button
//                   whileHover={{ scale: 1.02 }}
//                   key={i}
//                   onClick={() => handleOptionClick(opt)}
//                   className="w-full text-left px-3 py-2 bg-gray-100 rounded-lg hover:bg-gray-200 text-sm"
//                 >
//                   {opt}
//                 </motion.button>
//               ))}

//               {/* CALL */}
//               <a
//                 href="tel:9871238339"
//                 className="flex items-center justify-center gap-2 bg-gradient-to-r from-green-500 to-emerald-600 text-white py-2 rounded-lg shadow"
//               >
//                 <FaPhoneAlt /> Call Now
//               </a>

//             </div>

//           </motion.div>
//         )}
//       </AnimatePresence>
//     </div>
//   );
// };

// export default HelpCenter;
import { useState } from "react";
import { FaRobot, FaTimes, FaPhoneAlt, FaQuestionCircle } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";

const HelpCenter = () => {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([
    { type: "bot", text: "Hi 👋 How can I help you today?" }
  ]);

  const options = [
    "Order Status",
    "Return Policy",
    "Payment Issue",
    "Talk to Support"
  ];

  const handleOptionClick = (option) => {
    let reply = "";

    switch (option) {
      case "Order Status":
        reply = "📦 Track your order from 'My Orders' section.";
        break;
      case "Return Policy":
        reply = "🔁 7 days easy return available.";
        break;
      case "Payment Issue":
        reply = "💳 Try again or check payment status.";
        break;
      case "Talk to Support":
        reply = "📞 You can call support below 👇";
        break;
      default:
        reply = "Sorry, I didn't understand.";
    }

    setMessages((prev) => [
      ...prev,
      { type: "user", text: option },
      { type: "bot", text: reply }
    ]);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-4 text-gray-800">

      {/* 🔥 HEADER */}
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Help Center</h1>
        <p className="text-gray-500 text-sm">
          Get instant help or chat with us 🚀
        </p>
      </div>

      {/* 🔥 QUICK HELP CARDS */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-8">
        {options.map((item, i) => (
          <motion.div
            key={i}
            whileHover={{ y: -5 }}
            className="bg-white p-4 rounded-xl shadow-sm border cursor-pointer"
            onClick={() => handleOptionClick(item)}
          >
            <FaQuestionCircle className="text-green-500 mb-2" />
            <p className="text-sm font-medium">{item}</p>
          </motion.div>
        ))}
      </div>

      {/* 🔥 FAQ */}
      <div className="bg-white p-5 rounded-2xl shadow border mb-10">
        <h2 className="font-semibold text-lg mb-3">FAQs</h2>

        <div className="space-y-2 text-sm text-gray-600">
          <p>📦 How to track order?</p>
          <p>🔁 What is return policy?</p>
          <p>💳 Payment failed?</p>
          <p>🛡 Warranty details?</p>
        </div>
      </div>

      {/* 🔥 FLOAT BUTTON */}
      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        onClick={() => setOpen(true)}
        className="fixed bottom-6 right-6 bg-gradient-to-r from-green-500 to-emerald-600 text-white p-4 rounded-full shadow-xl z-50"
      >
        <FaRobot size={20} />
      </motion.button>

      {/* 🔥 CHATBOT */}
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 50, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 50 }}
            className="fixed bottom-24 right-4 sm:right-6 w-[90%] sm:w-[340px] bg-white rounded-2xl shadow-2xl flex flex-col overflow-hidden border z-50"
          >

            {/* HEADER */}
            <div className="bg-gradient-to-r from-green-500 to-emerald-600 text-white p-3 flex justify-between items-center">
              <div className="flex items-center gap-2">
                <FaRobot />
                <span className="font-semibold">Support Bot</span>
              </div>
              <FaTimes className="cursor-pointer" onClick={() => setOpen(false)} />
            </div>

            {/* MESSAGES */}
            <div className="p-3 h-[260px] overflow-y-auto space-y-2 flex flex-col">

              {messages.map((msg, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  className={`p-2 px-3 rounded-2xl text-sm max-w-[80%] flex items-center gap-2 ${
                    msg.type === "bot"
                      ? "bg-gray-100 text-gray-800 self-start"
                      : "bg-gradient-to-r from-green-500 to-emerald-600 text-white self-end ml-auto"
                  }`}
                >
                  {msg.type === "bot" && (
                    <FaRobot className="text-green-600 text-xs" />
                  )}
                  {msg.text}
                </motion.div>
              ))}

            </div>

            {/* OPTIONS */}
            <div className="p-3 border-t space-y-2 bg-white">

              {options.map((opt, i) => (
                <button
                  key={i}
                  onClick={() => handleOptionClick(opt)}
                  className="w-full text-left px-3 py-2 bg-gray-100 rounded-lg hover:bg-gray-200 text-sm text-gray-700"
                >
                  {opt}
                </button>
              ))}

              {/* CALL */}
              <a
                href="tel:9871238339"
                className="flex items-center justify-center gap-2 bg-gradient-to-r from-green-500 to-emerald-600 text-white py-2 rounded-lg shadow"
              >
                <FaPhoneAlt /> Call Now
              </a>

            </div>

          </motion.div>
        )}
      </AnimatePresence>

    </div>
  );
};

export default HelpCenter;